// extracted by mini-css-extract-plugin
module.exports = {"power-independence-A":"A_power-independence-A__RYSH0"};